import enFittings from './fittings/en.json'
import zhFittings from './fittings/zh-CN.json'
import arFittings from './fittings/ar.json'
import frFittings from './fittings/fr.json'
import deFittings from './fittings/de.json'
import itFittings from './fittings/it.json'
import esFittings from './fittings/es.json'
import trFittings from './fittings/tr.json'

// Locale -> fitting-name map. All eight locales have a fully-populated, key-parity
// map; getFittingName still falls back to the English map, then to prettify(),
// for any key that is somehow absent.
const maps = {
  en: enFittings,
  'zh-CN': zhFittings,
  ar: arFittings,
  fr: frFittings,
  de: deFittings,
  it: itFittings,
  es: esFittings,
  tr: trFittings
}

// Mirror of the historical formatSubLabel() prettify logic, used as the final
// fallback when a key is not present in any fitting-name map.
export function prettifyFittingKey(key) {
  return String(key)
    .replace(/_/g, ' ')
    .replace(/Type(\d+)/g, '- $1')
    .replace(/\b(PP R|PE 100|PVC U)\b/g, (m) => m.replace(' ', '-'))
}

export function getFittingName(key, locale) {
  if (key == null) return ''
  const map = maps[locale] || maps.en
  if (map && map[key] != null) return map[key]
  if (maps.en[key] != null) return maps.en[key]
  return prettifyFittingKey(key)
}

export default getFittingName
